// extracted by mini-css-extract-plugin
export default {"paragraphCaretFix":"LPSq+AjHKd4xN1sBJA5g3A==","placeholder":"aLIu4ipCWOQh5XOWaDl2Dw=="};